export interface ListStringOperationPayload {
  list: string[];
}

export interface SingleStringOperationPayload {
  string: string;
}

export type StringOperationPayload = ListStringOperationPayload | SingleStringOperationPayload;
